import iziToast from 'izitoast'
import { serializeErrorMessage } from '@/_helpers'

export default {
  actions: {
    // eslint-disable-next-line
    welcome ({state}, message) {
      iziToast.info({
        theme: 'dark',
        title: 'Halo',
        message: message,
      })
      // Notification.notify({
      //   message: message,
      //   icon: 'fas fa-smile',
      //   horizontalAlign: 'right',
      //   verticalAlign: 'bottom',
      //   type: 'success'
      // })
    },
    // eslint-disable-next-line
    success ({state}, message) {
      iziToast.success({
        title: 'Sukses',
        theme: 'dark',
        message: message
      })
      // Notification.notify({
      //   message: message,
      //   timeout: 10000,
      //   icon: 'fas fa-check',
      //   horizontalAlign: 'right',
      //   verticalAlign: 'bottom',
      //   type: 'success'
      // })
    },
    // eslint-disable-next-line
    notification ({state}, body) {
      iziToast.success({
        theme: 'dark',
        title: body.title,
        message: body.message,
        layout: 2,
        maxWidth: '360',
        buttons: [
          [
            '<button>Lihat</button>',
            function () {
              if (typeof body.redirect !== 'undefined') {
                window.location.href = body.redirect
              }
            },
            true // true to focus
          ]
        ]
      })
    },
    // eslint-disable-next-line
    infoOnTop ({state}, body) {
      iziToast.info({
        title: 'Info',
        theme: 'dark',
        // timeout: 10000000,
        message: body.message,
        position: 'topRight',
        closeOnClick: true,
        buttons: [
          [
            '<button>Lihat</button>',
            function () {
              body.callback()
            },
            true // true to focus
          ]
        ]
      })
      // Notification.notify({
      //   message: message,
      //   timeout: 10000,
      //   icon: 'fas fa-info',
      //   horizontalAlign: 'right',
      //   verticalAlign: 'bottom',
      //   type: 'info'
      // })
    },
    // eslint-disable-next-line
    info ({state}, message) {
      iziToast.info({
        title: 'Info',
        theme: 'dark',
        message: message,
      })
      // Notification.notify({
      //   message: message,
      //   timeout: 10000,
      //   icon: 'fas fa-info',
      //   horizontalAlign: 'right',
      //   verticalAlign: 'bottom',
      //   type: 'info'
      // })
    },
    // eslint-disable-next-line
    error ({state}, message) {
      iziToast.error({
        title: 'Error',
        theme: 'dark',
        message: serializeErrorMessage(message),
      })
      // let customMessage = Vue.component('custom-message', {
      //   render: (createElement) => {
      //     // let div = createElement('div')
      //     // console.log(serializeErrorMessage(message))
      //     // div.innerHTML = serializeErrorMessage(message).trim()
      //     // return div
      //     return createElement('div', {
      //       domProps: {
      //         innerHTML: serializeErrorMessage(message).trim()
      //       }
      //     })
      //   },
      //   // template: `<span>Some <b>bolded html text</b></span>`
      // })
      // Notification.notify({
      //   component: customMessage,
      //   // message: serializeErrorMessage(message),
      //   // message: serializeErrorMessage(message),
      //   timeout: 20000,
      //   icon: 'fas fa-exclamation',
      //   horizontalAlign: 'right',
      //   verticalAlign: 'bottom',
      //   type: 'danger'
      // })
    },
    // eslint-disable-next-line
    clear () {
      iziToast.destroy()
      // Notification.notifications().clear()
    }
  }
}
